import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useAppSelector } from "../../../app/hooks";
import { Transitions } from "../../../common/components/Transitions";
import { NavItems } from "../../../common/helpers/navigation";
import { sleepFor } from "../../../common/helpers/countHelper";
import { AssessmentShell } from "../components/AssessmentShell";
import VideoPlayer from "../../../common/components/VideoPlayer";
import { getInstructionFromStep } from "../../../common/helpers/instructionHelper";

export const AssessmentInstruction = (): JSX.Element => {
    const [errorLoadingVideo, setErrorLoadingVideo] = useState(false);
    const [currentCaption, setCurrentCaption] = useState("");

    const navigate = useNavigate();

    const currentFlow = useAppSelector((x) => x.assessmentFlow.currentFlow);
    const currentInstruction = useAppSelector((x) => x.assessmentFlow.flows[currentFlow]);

    const assessmentInstruction = useAppSelector((x) =>
        getInstructionFromStep(x.assessmentForm.instructions, currentInstruction.name)
    );

    useEffect(() => {
        if (errorLoadingVideo) {
            const instructions = assessmentInstruction.instructionText.split(";");

            instructions.forEach((instruction, index) => {
                setTimeout(() => {
                    setCurrentCaption(instruction);
                }, index * 3 * 2500);
            });

            setTimeout(() => {
                void handleOnEnd();
            }, (instructions.length + 1) * 3 * 1000);
        }
    }, [assessmentInstruction, errorLoadingVideo]);

    const handleOnVideoError = (): void => {
        setErrorLoadingVideo(true);
    };

    const handleOnEnd = async (): Promise<void> => {
        await sleepFor(3);

        if (currentFlow === 0) {
            navigate(NavItems.Assessments.Begin.path);
        } else {
            navigate(NavItems.Assessments.AssessmentPresentTargets.path);
        }
    };

    return (
        <AssessmentShell>
            {errorLoadingVideo && (
                <div className="columns">
                    <div className="column">
                        <Transitions currentCaption={currentCaption} />
                    </div>
                </div>
            )}
            {!errorLoadingVideo && (
                <VideoPlayer
                    url={assessmentInstruction.instructionVideoUrl}
                    onLoadError={handleOnVideoError}
                    onEnd={handleOnEnd}
                />
            )}
        </AssessmentShell>
    );
};
